import React from 'react';
import { CreditCardIcon, FileTextIcon, GlobeIcon, LockIcon, ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { miniTestimonials } from '../data/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const badges = [{
  icon: FileTextIcon,
  label: '100% Digital'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: GlobeIcon,
  label: 'Todos los países'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días sin preguntas'
}, {
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: CreditCardIcon,
  label: 'Pagás en la moneda de tu país'
}];
const stats = [{
  value: "+300",
  label: "personas confían en NATURIA"
}, {
  value: '6 tomos + 6 bonos',
  label: 'completamente listos'
}, {
  value: "4.7/5",
  label: 'calificación promedio'
}];
function Stars() {
  return <span className="flex items-center gap-0.5" aria-label="5 de 5 estrellas" data-id="element-104" data-mp="3d2tm12xxw8bd">
      {[0, 1, 2, 3].map(index => <StarIcon key={index} className="h-3.5 w-3.5 fill-mint-500 text-mint-500" aria-hidden="true" data-id="element-105" data-mp="384jtz17ihntz" />)}
    </span>;
}
export function Hero() {
  return <header className="relative overflow-hidden bg-mint-50" data-id="element-106" data-mp="3o7vllomspvze">
      <div className="mx-auto max-w-6xl px-6 pb-16 pt-14 sm:pt-20" data-id="element-107" data-mp="3o59cvlo65afl">
        <div className="grid items-center gap-14 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:gap-16" data-id="element-108" data-mp="399tckywzwiar">
          <div data-id="element-109" data-mp="3e7l8s54oaqkr">
            <Reveal data-id="element-110" data-mp="3eb91j22an8yf">
              <p className="text-sm font-semibold uppercase tracking-[0.18em] text-mint-700" data-id="element-111" data-mp="30hhp9lx6haz0">
                Naturia · MegaPack Salud Plena
              </p>
              <h1 className="mt-5 font-display text-4xl leading-[1.05] text-ink sm:text-5xl lg:text-6xl" data-id="element-112" data-mp="35aud3tu19dqp">
                Tu intestino inflamado,
                <span className="block text-mint-700" data-id="element-113" data-mp="2vies0nnfw91l">Un protocolo innovador que lo resuelve en 15 días.</span>
              </h1>
              <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft sm:text-xl" data-id="element-114" data-mp="2hkglg4fd1gwn">
                Transformá tu inflamación sin dietas restrictivas ni confusión sobre qué comer. Es simple y fácil de implementar. No es necesario saber cocinar! 
              </p>
            </Reveal>

            <Reveal delay={0.06} data-id="element-115" data-mp="najgjljwi9dy">
              <ul className="mt-8 flex flex-wrap items-center gap-2.5" data-id="element-116" data-mp="n98g9vpnzjrl">
                {badges.map(badge => <li key={badge.label} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-white px-3.5 py-2 text-sm font-medium text-ink-soft ring-1 ring-inset ring-mint-200" data-id="element-117" data-mp="ia5k70rnwnvr">
                    <badge.icon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-118" data-mp="1ayt68yk8jhad" />
                    {badge.label}
                  </li>)}
              </ul>

              <div className="mt-8" data-id="element-119" data-mp="111etb8xitamt">
                <CtaButton data-id="element-120" data-mp="114kispa2aej2">Quiero el Megapack</CtaButton>
              </div>

              <ul className="mt-7 flex flex-wrap gap-x-6 gap-y-3" data-id="element-121" data-mp="x0l84nbgq9xm">
                {trust.map(item => <li key={item.label} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-ink-muted" data-id="element-122" data-mp="3ltqclcptivti">
                    <item.icon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-123" data-mp="3htg7s3dribg8" />
                    {item.label}
                  </li>)}
              </ul>
            </Reveal>
          </div>

          <Reveal delay={0.1} data-id="element-124" data-mp="21b66k5ekreqc">
            <img src="https://cdn.magicpatterns.com/uploads/2kjyTbTgABXK8252TNBU9A/7722c05e-c1e3-4cb9-83af-899501559c43_(1).png" alt="Los 6 tomos del MegaPack Salud Plena en formato digital, vistos en libros y tablet" className="w-full rounded-3xl object-cover shadow-lift" width={1200} height={900} style={{
            objectFit: "cover",
            width: "304px",
            height: "473px"
          }} data-id="element-125" data-mp="26a99nkazvavo" />
          </Reveal>
        </div>

        <Reveal delay={0.05} data-id="element-126" data-mp="2p0qnkir641wz">
          <dl className="mt-16 grid gap-px overflow-hidden rounded-2xl bg-mint-200 sm:grid-cols-3" data-id="element-127" data-mp="2p1jxfslfb7jc">
            {stats.map(stat => <div key={stat.value} className="bg-white px-6 py-6" data-id="element-128" data-mp="2tz1xsuldkefq">
                <dt className="font-display text-2xl text-ink" data-id="element-129" data-mp="un99dmcnkhem">{stat.value}</dt>
                <dd className="mt-1 text-sm text-ink-muted" data-id="element-130" data-mp="zlappzip22me">{stat.label}</dd>
              </div>)}
          </dl>
        </Reveal>

        <Reveal delay={0.05} data-id="element-131" data-mp="4acmxeox1t8h">
          <ul className="mt-10 grid gap-6 sm:grid-cols-3" data-id="element-132" data-mp="49jd24ununm4">
            {miniTestimonials.map(item => <li key={item.initials} className="flex h-full flex-col border-t border-mint-200 pt-5" data-id="element-133" data-mp="3vh5km8ki3a89">
                <Stars data-id="element-134" data-mp="e91w8j2qy5d4" />
                <p className="mt-3 text-[15px] leading-relaxed text-ink" data-id="element-135" data-mp="e77ibopw7dij">
                  “{item.quote}”
                </p>
                <p className="mt-auto pt-4 text-sm text-ink-muted" data-id="element-136" data-mp="3hpr180mol70o">
                  {item.name} · {item.location}
                </p>
              </li>)}
          </ul>
        </Reveal>
      </div>
    </header>;
}